"use client";

import { useFormStatus } from "react-dom";
import { Button, type ButtonProps } from "./Button";

/** Submit button for `<form action={serverAction}>`: shows the pending state while the action runs. */
export function SubmitButton(props: Omit<Extract<ButtonProps, { iconOnly?: false }>, "type">) {
  const { pending } = useFormStatus();
  return <Button {...props} type="submit" loading={props.loading || pending} />;
}
